import React from "react"
import Form from "react-bootstrap/Form"
import EditproductHook from "../Componentslogic/productsLogic/EditproductHook"
import { useParams } from "react-router-dom"
import { Link } from "react-router-dom"
import { motion as m } from "framer-motion"
import UsefetchCollectionNonrealtime from "../Componentslogic/UsefetchcollectionNonrealtime"

export const Editproduct = () => {
  const { data } = UsefetchCollectionNonrealtime("Categories")
  const { id } = useParams()
  const [
    name,
    description,
    priceBefore,
    ,
    handleSubmitproduct,
    OnchangeName,
    OnchangeDescription,
    OnchangeCatid,
    Onchangepricebefore,
    ,
    catId,
    catName,
  ] = EditproductHook(id)

  return (
    <m.div
      initial={{ opacity: 0, x: 15 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
      className="add-product-container"
    >
      <div className="add-product-section">
        <h2 className="section-title">Edit Product</h2>
        <form className="product-form">
          {/* Product Name */}
          <input
            onChange={OnchangeName}
            value={name}
            className="form-input"
            name="Name"
            placeholder="Edit Product Name"
            type="text"
          />

          {/* Product Description */}
          <textarea
            onChange={OnchangeDescription}
            value={description}
            className="form-textarea"
            name="Description"
            placeholder="Edit Product Description"
            rows="3"
          />

          {/* Select Category */}
          <Form.Select
            value={catId ? `${catId}|${catName}` : ""}
            onChange={OnchangeCatid}
            aria-label="Select Category"
            className="form-input"
          >
            <option>Select category please</option>
            {data
              ? data.map((i, index) => (
                  <option key={index} value={`${i.id}|${i.name}`}>
                    {i.name}
                  </option>
                ))
              : null}
          </Form.Select>

          {/* Product Price */}
          <input
            onChange={Onchangepricebefore}
            value={priceBefore}
            className="form-input"
            name="Price"
            placeholder="Edit Product Price"
            type="number"
          />

          {/* Update Button */}
          <button onClick={handleSubmitproduct} className="btns-Admin">
            Update
          </button>

          {/* Back Button */}
          <Link to="/adminmanagement" style={{ textDecoration: "none" }}>
            <button className="btns-Admin">
              <strong>Back</strong>
            </button>
          </Link>
        </form>
      </div>
    </m.div>
  )
}
